import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class LocationManagerService {

  url = environment.SERVER_URL + 'icrweb/'
  constructor(private http: HttpClient) { }

  branchListView(req_obj) {
    return this.http.post(this.url + "branchList", req_obj, {
      observe: 'body'
    });
  }

  loadMasters() {
    return this.http.get(this.url + 'master')
  }

  postBranchForm(data) {
    return this.http.post(this.url + 'saveBranchData?token=e8d17733-f402-11e9-8c79-42010af00005&lngId=1', data)
  }

  getBranchDetails(request) {
    return this.http.post(this.url + 'home/get_location_detail_with_master_data', request)
  }

  getGeoDecoder(lat, long) {
    return this.http.get("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + lat + "," + long + "&key=AIzaSyBW8ims4u7KdubV_y-qSDjEwGRwD48UN5U")
  }

  saveBranchDetails(branchListView) {
    return this.http.post(this.url + 'home/save_location_master_data', branchListView)
  }
}
